import React, { useState } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const TodoContext = React.createContext();
const LOCAL_TODOS = "TODOS_V1";

export function TodoProvider({children}) {
  const {item: todosList, saveItem: saveTodosList, loading, error} = useLocalStorage(LOCAL_TODOS, []);
  const [searchVal, setSearchVal] = useState('');
  const [openModal, setOpenModal] = useState(false);

  // Estados derivados:
  const completedTodos = todosList.filter(todo => todo.completed).length;
  const totalTodos = todosList.length;

  const filteredTodos = todosList.filter(
    todo => todo.text.toLocaleUpperCase()
      .includes(
        searchVal.toLocaleUpperCase()
      )
  );

  const handleSearch = (event) => {
    setSearchVal(event.target.value);
  }

  const addTodo = (newValue) => {
    const newTodos = [...todosList];
    newTodos.push({
      id: newValue.replaceAll(' ', '-'),
      text: newValue,
      completed: false
    });
    saveTodosList(newTodos);
  };

  const handleComplete = (id) => {
    const newTodos = [...todosList];
    const todoIndex = newTodos.findIndex(
      todo => todo.id === id
    );
    newTodos[todoIndex].completed = !newTodos[todoIndex].completed;
    saveTodosList(newTodos);
  };

  const handleDelete = id => {
    const newTodos = [...todosList];
    const todoIndex = newTodos.findIndex(
      todo => todo.id === id
    );
    newTodos.splice(todoIndex, 1);
    saveTodosList(newTodos);
  };

  const propsStore = {
    loading,
    error,
    completedTodos,
    totalTodos,
    searchVal,
    handleSearch,
    filteredTodos,
    handleComplete,
    handleDelete,
    openModal,
    setOpenModal,
    addTodo
  };

  return (
    <TodoContext.Provider value={propsStore}>
      {children}
    </TodoContext.Provider>
  )
}